// 报表api
import request from '@/util/request'
import * as lib from '@/util/lib.js'
import { getLanguageStr } from '@/util/language'
// 获取电站统计报表数据  预览
export function getReportStats (data) {
	return request({
		url: `/maintain_old/report/station/stats`,
		method: 'get',
		params: data
	})
}

// 导出电站统计
export function getReportExport (data) {
	return request({
		url: `/maintain_old/report/station/stats/export`,
		method: 'get',
		params: data,
		responseType: 'blob'
	})
}

// 获取设备列表
export function apiGetDeviceList (getFrom, data) {
	let url = ''
	switch (getFrom) { // 从不同的部分获取
		case 'plant':
			url = '/maintain-s/power/system/deviceList'
			break
		case 'device':
			url = '/report-s/report/device-list'
			break
	}
	return request({
		url,
		method: 'post',
		params: {
			size: data.size,
			page: data.page,
			'order.direction': 'DESC',
			'order.property': 'collection_time'
		},
		data: $.extend(true, data, { language: stage.languageId })
	})
	// return new Promise(resolve=>{
	// 	resolve({
	// 		total:2,
	// 		data:[
	// 			{
	// 				"deviceId":123,
	// 				"deviceSn":"123",
	// 				"productId":"0_5701_1",
	// 				"siteId":2
	// 			},
	// 			{
	// 				"deviceId":111,
	// 				"deviceSn":"121233",
	// 				"productId":"0_5701123_1",
	// 				"siteId":22
	// 			}
	// 		]
	// 	});
	// });
}

// 预览报表
export function apiPreview (datas) {
	let data = _.cloneDeep(datas)
	data.reportFields.push({
		'name': getLanguageStr('word210', '时间'),
		'storageName': 'COLLECTION_TIME'
	})
	let name = data.typeName
	// data.typeName = name
	let url = ''
	if (name == getLanguageStr('word204', '电站')) {
		url = '/maintain-s/station/report/query'
	} else { // (name == getLanguageStr('word35', '逆变器')||name == getLanguageStr('word39', '电表'))
		url = '/report-s/report/get-data'
	}
	return request({
		url: url,
		method: 'post',
		data
	})
	// switch(){

	// }
	// return new Promise(resolve=>{
	// 	resolve({
	// 		"titleList": [
	// 			"设备名称",
	// 			"SN号",
	// 			"所属系统",
	// 			"所属父设备",
	// 			"时间",
	// 			"直流电压PV1",
	// 			"交流输出总功率（有功）"
	// 		],
	// 		"dataPage": {
	// 			"total": 297,
	// 			"data": [
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560405650",
	// 					"2162.80",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560405950",
	// 					"4651.60",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560406250",
	// 					"1835.30",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560406550",
	// 					"1089.20",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560406850",
	// 					"3128.60",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560407150",
	// 					"3673.30",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560407450",
	// 					"1188.90",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560407750",
	// 					"4640.20",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560408050",
	// 					"6546.90",
	// 					"0"
	// 				],
	// 				[
	// 					"逆变器",
	// 					"123456",
	// 					"开发调试——储能",
	// 					"dev123456",
	// 					"1560408350",
	// 					"1224.90",
	// 					"0"
	// 				]
	// 			]
	// 		}
	// 	});
	// });
}

export function apiDeviceParam (data) {
	return request({
		url: `/report-s/report/device-params`,
		method: 'post',
		// params: data,
		data
	})
}

// 下载、导出报表
export function apiReportDownLoad (datas, type) {
	let data = _.cloneDeep(datas)
	switch (type) {
		case 'STATION':
				if(data.qtyType=="single"){
					data.reportFields.push({
						'name': getLanguageStr('word210', '时间'),
						'storageName': 'COLLECTION_TIME'
					});
				}
				return request({
					url: `/maintain-s/station/report/export`,
					method: 'post',
					responseType: 'blob',
					// params: data,
					data
				})
			break
		default:
				data.reportFields.push({
					'name': getLanguageStr('word210', '时间'),
					'storageName': 'COLLECTION_TIME'
				});
				return request({
					url: `/report-s/report/export`,
					method: 'post',
					responseType: 'blob',
					// params: data,
					data
				})
			break
	}
}

// 电站参数接口模拟器
export function apiStationParams (data) {
	let p = new Promise((resolve, reject) => {
		let response = []
		// 多 按日
		if (data.qtyType === 'multiple' && data.timeDimension === 2) {
			response = [
				{
					name: getLanguageStr('word358', '当日发电量') + ' (kWh)',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word1882', '当日满发小时') + ' (h)',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1726', '当日PR') + '(%)',
					storageName: 'PR',
					readCode: 'pr'
				}
			]
		}
		// 多 按月
		if (data.qtyType === 'multiple' && data.timeDimension === 3) {
			response = [
				{
					name: getLanguageStr('word359', '当月发电量') + ' (kWh)',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word1728', '当月满发小时') + '(h)',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1730', '当月PR') + '(%)',
					storageName: 'PR',
					readCode: 'pr'
				}
			]
		}
		// 单个（分布式全额上网） 按分钟
		if (data.qtyType === 'single' && data.timeDimension === 1 && (data.gridInterconnectionType === 'DISTRIBUTED_FULLY'||data.gridInterconnectionType === 'CENTRALIZED_FULLY')) {
			response = [
				{
					name: getLanguageStr('word176', '发电功率') + '（W）',
					storageName: 'GENERATE_POWER',
					readCode: 'generatePower'
				},
				{
					name: getLanguageStr('word563', '温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1470', '天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1211', '辐照强度') + '（W/㎡）',
					storageName: 'IRRADIATE_INTENSITY',
					readCode: 'irradiateIntensity'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word347', '交流输出总功率') + '（W）',
					storageName: 'INVERTER_POWER',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word817', '有功总功率') + '（W）',
					storageName: 'METER_POWER',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（分布式全额上网）按日
		if (data.qtyType === 'single' && data.timeDimension === 2 &&  (data.gridInterconnectionType === 'DISTRIBUTED_FULLY'||data.gridInterconnectionType === 'CENTRALIZED_FULLY')) {
			response = [
				{
					name: getLanguageStr('word358', '当日发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word1731', '当日温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1732', '当日天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1882', '当日满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1725', '当日辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1726', '当日PR') + '(%)',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word358', '当日发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1878', '日正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1879', '日反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（分布式全额上网）按月
		if (data.qtyType === 'single' && data.timeDimension === 3 &&  (data.gridInterconnectionType === 'DISTRIBUTED_FULLY'||data.gridInterconnectionType === 'CENTRALIZED_FULLY')) {
			response = [
				{
					name: getLanguageStr('word359', '当月发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word1729', '当月辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1728', '当月满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1730', '当月PR') + '（%）',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word359', '当月发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1880', '月正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1881', '月反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（分布式自发自用余电上网）按分钟
		if (data.qtyType === 'single' && data.timeDimension === 1 && data.gridInterconnectionType === 'EXCESS') {
			response = [
				{
					name: getLanguageStr('word176', '发电功率') + '（W）',
					storageName: 'GENERATE_POWER',
					readCode: 'generatePower'
				},
				{
					name: getLanguageStr('word977', '用电功率') + '（W）',
					storageName: 'USE_POWER',
					readCode: 'usePower'
				},
				{
					name: getLanguageStr('word190', '电网功率') + '（W）',
					storageName: 'WIRE_POWER',
					readCode: 'wirePower'
				},
				{
					name: getLanguageStr('word177', '并网功率') + '（W）',
					storageName: 'GRID_POWER',
					readCode: 'gridPower'
				},
				{
					name: getLanguageStr('word168', '购电功率') + '（W）',
					storageName: 'BUY_POWER',
					readCode: 'buyPower'
				},
				{
					name: getLanguageStr('word563', '温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1470', '天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1211', '辐照强度') + '（W/㎡）',
					storageName: 'IRRADIATE_INTENSITY',
					readCode: 'irradiateIntensity'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word347', '交流输出总功率') + '（W）',
					storageName: 'INVERTER_POWER',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word817', '有功总功率') + '（W）',
					storageName: 'METER_POWER',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（分布式自发自用余电上网）按日
		if (data.qtyType === 'single' && data.timeDimension === 2 && data.gridInterconnectionType === 'EXCESS') {
			response = [
				{
					name: getLanguageStr('word358', '当日发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word527', '当日用电量') + '（kWh）',
					storageName: 'USE_VALUE',
					readCode: 'useValue'
				},
				{
					name: getLanguageStr('word501', '当日并网量') + '（kWh）',
					storageName: 'GRID_VALUE',
					readCode: 'gridValue'
				},
				{
					name: getLanguageStr('word502', '当日购电量') + '（kWh）',
					storageName: 'BUY_VALUE',
					readCode: 'buyValue'
				},
				{
					name: getLanguageStr('word1731', '当日温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1732', '当日天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1725', '当日辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1882', '当日满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1726', '当日PR') + '（%）',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word358', '当日发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1878', '日正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1879', '日反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（分布式自发自用余电上网）按月
		if (data.qtyType === 'single' && data.timeDimension === 3 && data.gridInterconnectionType === 'EXCESS') {
			response = [
				{
					name: getLanguageStr('word359', '当月发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word528', '当月用电量') + '（kWh）',
					storageName: 'USE_VALUE',
					readCode: 'useValue'
				},
				{
					name: getLanguageStr('word503', '当月并网量') + '（kWh）',
					storageName: 'GRID_VALUE',
					readCode: 'gridValue'
				},
				{
					name: getLanguageStr('word504', '当月购电量') + '（kWh）',
					storageName: 'BUY_VALUE',
					readCode: 'buyValue'
				},
				{
					name: getLanguageStr('word1729', '当月辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1728', '当月满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1730', '当月PR') + '（%）',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word359', '当月发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1880', '月正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1881', '月反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（储能系统） 按分钟
		if (data.qtyType === 'single' && data.timeDimension === 1 && data.gridInterconnectionType === 'BATTERY_BACKUP') {
			response = [
				{
					name: getLanguageStr('word176', '发电功率') + '（W）',
					storageName: 'GENERATE_POWER',
					readCode: 'generatePower'
				},
				{
					name: getLanguageStr('word977', '用电功率') + '（W）',
					storageName: 'USE_POWER',
					readCode: 'usePower'
				},
				{
					name: getLanguageStr('word190', '电网功率') + '（W）',
					storageName: 'WIRE_POWER',
					readCode: 'wirePower'
				},
				{
					name: getLanguageStr('word177', '并网功率') + '（W）',
					storageName: 'GRID_POWER',
					readCode: 'gridPower'
				},
				{
					name: getLanguageStr('word168', '购电功率') + '（W）',
					storageName: 'BUY_POWER',
					readCode: 'buyPower'
				},
				{
					name: getLanguageStr('plant366', '电池功率') + '（W）',
					storageName: 'BATTERY_POWER',
					readCode: 'batteryPower'
				},
				{
					name: getLanguageStr('word1883', '充电功率') + '（W）',
					storageName: 'CHARGE_POWER',
					readCode: 'chargePower'
				},
				{
					name: getLanguageStr('word1884', '放电功率') + '（W）',
					storageName: 'DISCHARGE_POWER',
					readCode: 'dischargePower'
				},
				{
					name: getLanguageStr('word1009', '电池剩余容量') + '（%）',
					storageName: 'BATTERY_SOC',
					readCode: 'batterySoc'
				},
				{
					name: getLanguageStr('word563', '温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1470', '天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1211', '辐照强度') + '（W/㎡）',
					storageName: 'IRRADIATE_INTENSITY',
					readCode: 'irradiateIntensity'
				},
				{
					name: getLanguageStr('word35', '逆变器') + '$' + getLanguageStr('word347', '交流输出总功率') + '（W）',
					storageName: 'INVERTER_POWER',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word817', '有功总功率') + '（W）',
					storageName: 'METER_POWER',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（储能系统）按日
		if (data.qtyType === 'single' && data.timeDimension === 2 && data.gridInterconnectionType === 'BATTERY_BACKUP') {
			response = [
				{
					name: getLanguageStr('word358', '当日发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word527', '当日用电量') + '（kWh）',
					storageName: 'USE_VALUE',
					readCode: 'useValue'
				},
				{
					name: getLanguageStr('word501', '当日并网量') + '（kWh）',
					storageName: 'GRID_VALUE',
					readCode: 'gridValue'
				},
				{
					name: getLanguageStr('word502', '当日购电量') + '（kWh）',
					storageName: 'BUY_VALUE',
					readCode: 'buyValue'
				},
				{
					name: getLanguageStr('word548', '当日充电量') + '（kWh）',
					storageName: 'CHARGE_VALUE',
					readCode: 'chargeValue'
				},
				{
					name: getLanguageStr('word549', '当日放电量') + '（kWh）',
					storageName: 'DISCHARGE_VALUE',
					readCode: 'dischargeValue'
				},
				{
					name: getLanguageStr('word1731', '当日温度') + '（℃）',
					storageName: 'TEMP',
					readCode: 'temp'
				},
				{
					name: getLanguageStr('word1732', '当日天气'),
					storageName: 'WEATHER',
					readCode: 'weather'
				},
				{
					name: getLanguageStr('word1725', '当日辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1882', '当日满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1726', '当日PR') + '（%）',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35+$+word358', '逆变器当日发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39+$+word1878', '电表日正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39+$+word1879', '电表日反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		// 单个（储能系统）按月
		if (data.qtyType === 'single' && data.timeDimension === 3 && data.gridInterconnectionType === 'BATTERY_BACKUP') {
			response = [
				{
					name: getLanguageStr('word359', '当月发电量') + '（kWh）',
					storageName: 'GENERATE_VALUE',
					readCode: 'generateValue'
				},
				{
					name: getLanguageStr('word528', '当月用电量') + '（kWh）',
					storageName: 'USE_VALUE',
					readCode: 'useValue'
				},
				{
					name: getLanguageStr('word503', '当月并网量') + '（kWh）',
					storageName: 'GRID_VALUE',
					readCode: 'gridValue'
				},
				{
					name: getLanguageStr('word504', '当月购电量') + '（kWh）',
					storageName: 'BUY_VALUE',
					readCode: 'buyValue'
				},
				{
					name: getLanguageStr('word550', '当月充电量') + '（kWh）',
					storageName: 'CHARGE_VALUE',
					readCode: 'chargeValue'
				},
				{
					name: getLanguageStr('word551', '当月放电量') + '（kWh）',
					storageName: 'DISCHARGE_VALUE',
					readCode: 'dischargeValue'
				},
				{
					name: getLanguageStr('word1729', '当月辐照量') + '（kWh/㎡）',
					storageName: 'IRRADIATE',
					readCode: 'irradiate'
				},
				{
					name: getLanguageStr('word1728', '当月满发小时') + '（h）',
					storageName: 'FULL_POWER_HOURS',
					readCode: 'fullPowerHours'
				},
				{
					name: getLanguageStr('word1730', '当月PR') + '（%）',
					storageName: 'PR',
					readCode: 'pr'
				},
				{
					name: getLanguageStr('word35+$+word359', '逆变器当月发电量') + '（kWh）',
					storageName: 'INVERTER_GENERATION',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1880', '月正向总电能') + '（kWh）',
					storageName: 'METER_FORWARD',
					readCode: '',
					deviceField: true
				},
				{
					name: getLanguageStr('word39', '电表') + '$' + getLanguageStr('word1881', '月反向总电能') + '（kWh）',
					storageName: 'METER_BACKWARD',
					readCode: '',
					deviceField: true
				}
			]
		}
		resolve(response)
	})
	return p
}



// WEBPACK FOOTER //
// ./src/api/application/report.js